<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: p_fy
 * @LastEditTime: 2019-07-18 21:01:49
 * @Description: 邀请、预约企业信息列表
 -->
<template>

  <div class="transport-news">
  
    <el-dialog
      :visible.sync="companyVisible"
      :title="titleName"
      width="80%"
      @close="$emit('close', false)"
    >
      <div class="company-head">
        <!-- 查询表单  -->
        <div class="company-head-form">
          <div class="fileds">
            <el-form ref="form" :model="companyParams" :inline="true">
              <div class="company-condition">
                <el-form-item label="公司名称:" prop="companyName">
                  <el-input v-model="companyParams.companyName" v-input-filter placeholder="请输入" />
                </el-form-item>
                <el-form-item label="联系人:" prop="companyContact">
                  <el-input v-model="companyParams.companyContact" v-input-filter placeholder="请输入" />
                </el-form-item>
                <el-form-item :label="wareOrdInvType == 'order' ? '预约时间:' : '邀请时间:'" prop="daterangeArr">
                  <!--:picker-options="pickerOptions"-->
                  <el-date-picker
                    v-model="companyParams.daterangeArr"
                    type="daterange"
                    range-separator="至"
                    :editable="false"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :value-format="'yyyy-MM-dd HH:mm:ss'"
                    :format="'yyyy-MM-dd HH:mm:ss'"
                    @change="setLeaseStart"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="loadcompanyData"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="resetForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-loading="viewManager.loading" class="company-data">
          <div class="company-data-header">
            <ul>
              <li>公司名称</li>
              <li>公司地址</li>
              <li>联系人</li>
              <li>联系人电话</li>
              <li>{{ wareOrdInvType == 'order' ? '预约时间' : '邀请时间' }}</li>
            </ul>
          </div>
          <div class="company-data-body">
            <template v-if="!viewManager.loading && companyData.length < 1">
              <div class="no-data-info">
                <font>暂无匹配数据</font>
              </div>
            </template>
            <template v-for="(item, index) of companyData">
              <div :key="index" class="data-item">
                <ul>
                  <el-tooltip class="item" effect="dark" :content="item.companyName" placement="top">
                    <li :title="item.companyName">{{ item.companyName }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.companyAddress" placement="top">
                    <li :title="item.companyAddress">{{ item.companyAddress }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.companyContact" placement="top">
                    <li :title="item.companyContact">{{ item.companyContact }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.contactTel" placement="top">
                    <li :title="item.contactTel">{{ item.contactTel }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.createDate" placement="top">
                    <li :title="item.createDate">{{ item.createDate }}</li>
                  </el-tooltip>
                </ul>
              </div>
            </template>
          </div>
          <div class="company-data-pagination">
            <el-pagination
              :current-page="companyPagination.pageNo"
              :total="companyPagination.total"
              :page-size="companyPagination.pageSize"
              layout="prev, pager, next, jumper,total, sizes"
              @current-change="companyChangeCurrent"
              @size-change="companyChangeSize"
            />
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { findOrderCompany, findinviteCompany } from '@/api/personal/store/warehouseCompany'

// import { tableClass } from '@/api/cloud/storage-demand-info/components/StorageDemandItemsParam' // 仓储供给信息、表单参数列表

// const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)
export default {
  name: 'WarehouseCompany',
  components: {},
  props: {
    companyManager: { type: Boolean, default: () => false },
    companyForm: { type: Object, default: () => {} },
    warehousingType: { type: String, default: () => '1' },
    wareOrdInvType: { type: String, default: () => 'order' },
    titleName: { type: String, default: () => '邀请企业信息' },
    warehouseType: { type: String, default: () => '' }
  },
  data() {
    return {
      companyVisible: this.companyManager,
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 86400000
      //   }
      // },
      companyPagination: { // 分页参数
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      companyData: [],
      viewManager: {
        loading: true
      },
      allSelection: false,
      state: false,
      companyParams: {
        companyName: null,
        companyContact: null,
        daterangeArr: null,
        leaseStartTime: null,
        leaseEndTime: null
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    companyManager() {
      this.companyVisible = this.companyManager
      if (this.companyVisible) {
        this.loadcompanyData()
      }
    }
  },
  created() {
  },
  methods: {
    // 日期处理
    setLeaseStart(res) {
      if (res == null) {
        return false
      }
      this.companyParams.leaseStartTime = res[0]
      this.companyParams.leaseEndTime = res[1]
    },
    // 重置表单
    resetForm() {
      this.$refs['form'].resetFields()
      this.companyParams.daterangeArr = null
      this.companyParams.leaseStartTime = null
      this.companyParams.leaseEndTime = null
      this.loadcompanyData()
    },
    // 分页监听
    companyChangeSize(size) {
      this.companyPagination.pageSize = size
      this.loadcompanyData()
    },
    // 分页监听
    companyChangeCurrent(current) {
      this.companyPagination.pageNo = current
      this.loadcompanyData()
    },
    // 列表查询
    loadcompanyData() {
      this.viewManager.loading = true
      if (this.wareOrdInvType == 'order') {
        // 预约查询
        const params = Object.assign(this.companyPagination, this.companyParams)
        params.userId = this.userInfo.userId
        params.demandType = this.warehousingType
        params.supplyId = this.companyForm.id
        params.daterangeArr = null
        findOrderCompany(params).then((res) => {
          const invit = []
          res.result.rows.forEach(res => {
            if (res != null) {
              res.hidden = true
              res.selection = false
              invit.push(res)
            }
          })
          this.companyPagination.total = res.result.total
          this.companyData = invit
        }).catch((err) => {
          this.companyPagination.total = this.companyData.length
          console.log(err)
        }).finally(() => {
          this.viewManager.loading = false
        })
      } else {
        // 罐区查询
        const params = Object.assign(this.companyPagination, this.companyParams)
        params.warehouseType = this.warehouseType
        params.userId = this.userInfo.userId
        params.warehousingType = this.warehousingType
        params.wareId = this.companyForm.id
        params.daterangeArr = null
        findinviteCompany(params).then((res) => {
          const invit = []
          res.result.rows.forEach(res => {
            if (res != null) {
              res.hidden = true
              res.selection = false
              invit.push(res)
            }
          })
          this.companyPagination.total = res.result.total
          this.companyData = invit
        }).catch((err) => {
          this.companyPagination.total = this.companyData.length
          console.log(err)
        }).finally(() => {
          this.viewManager.loading = false
        })
      }
    },
    // 多选
    companySelSummit() {
      const selData = []
      this.companyData.forEach(res => {
        if (res.selection) {
          selData.push(res.id)
        }
      })
    },
    // 查询
    companyFormSummit() {
      this.loadcompanyData()
    },
    toggleState() {
      this.state = !this.state
      this.loadcompanyData()
    }
  }
}
</script>

<style scoped lang='scss'>
  $main-color: #be2316;
  .transport-news{
    margin-bottom: 1rem;
  }
  /deep/.company-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .company-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        width: 100%;
        // flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
        .company-condition{
          display: flex;
          flex-wrap: wrap;
          /deep/.el-form-item .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            width: 217px;
            .company-area{
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #FFF;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #DCDFE6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              transition: border-color .2s cubic-bezier(.645,.045,.355,1);
              width: 100%;
              /deep/.el-form-item__content{
                width: auto;
              }
              &:focus {
                  border-color: #409EFF;
                  outline: 0;
              }
              &:hover {
                  border-color: #C0C4CC;
              }
              .el-form-item{
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;
                /deep/.el-input .el-input__inner {
                    border: 0px solid #DCDFE6;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                }
              }
            }
          }
          .el-form-item{
              display: flex;
              -webkit-box-pack: end;
              -ms-flex-pack: end;
              justify-content: flex-end;
              padding-right: 22px;
              width: 50%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              margin-right: 0 !important;
          }
        }
      }
      .buttons {
        flex: 0 1 35%;
        text-align: center;
        // display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
  /deep/.main-wrap{
    margin-top: 1rem;
    .main{
      width: 1200px;
      margin: 0 auto 1rem;
      border:1px solid rgba(229,229,229,1);
      box-sizing: border-box;
      .el-form-item{
        padding-left: 20px;
        padding-right: 20px;
        .el-tag{
          margin-right: 1rem;
        }
      }
      .el-form{
        .selected-conditions{
          background-color: #F6F6F6;
          .el-form-item__content{
            display: flex;
            flex-wrap: wrap;
            .el-tag{
              margin-top: auto;
              margin-bottom: auto;
            }
          }
          .clear-conditions{
            cursor: pointer;
            color:  #999999;
            align-items: flex-end;
            display: block;
            margin-left: auto;
          }
        }
        .capacity-content{
          .el-form-item__content{
            display: flex;
          }
          .el-input{
            margin-right: 1rem;
            width: 80px;
          }
          .des{
            margin-right: 1rem;
          }
          .el-button-ml{
            background-color: #BE2316;
            color:#ffffff;
          }
        }
        /*复选组样式 start*/
        .el-checkbox-button{
          margin-right: 1rem;
        }
        .el-checkbox-button:first-child .el-checkbox-button__inner{
          border-radius:0!important;
        }
        .el-checkbox-button:last-child .el-checkbox-button__inner{
          border-radius:0!important;
        }
        .el-checkbox-button.is-checked .el-checkbox-button__inner{
          background-color: #BE2316;
          border-color:#BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }
        .el-checkbox-button__inner:hover{
          color: #BE2316;
        }
        .el-checkbox-button .el-checkbox-button__inner{
          border:none !important;
        }
        .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner{
          border-left-color: #BE2316
        }
        /*复选组样式 end*/
        /*单选组样式 start*/
        .el-radio-button{
          margin-right: 1rem;
        }
        .el-radio-button:first-child .el-radio-button__inner{
          border-radius:0!important;
        }
        .el-radio-button:last-child .el-radio-button__inner{
          border-radius:0!important;
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner{
          background-color: #BE2316;
          border-color:#BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }
        .el-radio-button__inner:hover{
          color: #BE2316;
        }
        .el-radio-button .el-radio-button__inner{
          border:none !important;
        }
        .el-radio-button.is-checked:first-child .el-radio-button__inner{
          border-left-color: #BE2316
        }
        /*单选组样式 end*/
        .transport-data{
          display: flex;
          .el-input{
            margin-right: 1rem;
          }
          .des{
            margin-right: 1rem;
          }
        }
        .form-item{
          margin-right: 0;
          .form-item-btn{
            background: #BE2316;
            border: none;
            i{
              font-size: 14px;
              padding-right: 10px;
            }
          }
        }
      }
    }
    .content{
      position: relative;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 50px;
      .content-img{
        width: 1200px;
      }
      .content-shoucang-tc{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -85px;
        margin-top: -35px;
      }
      .content-baojia{
        position: absolute;
        width: 50px;
        height: 100%;
        right: 0;
        top: 0;
      }
      .content-shoucang{
        position: absolute;
        width: 50px;
        height: 100%;
        right: 50px;
        top: 0;
      }

    }
    /*表格相关*/
    .table-wrap{
      width: 1200px;
      margin: 0 auto;
    }
  }

  .company-data {

    .company-form{
      .condition-group{
        margin-top: 0.5rem;
        padding-left: 8px;
      }
    }
    .company-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          padding: 5px 0.4%;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 20%;
          }
          &:nth-child(2) {
            flex-basis: 20%;
          }
          &:nth-child(3) {
            flex-basis: 20%;
          }
          &:nth-child(4) {
            flex-basis: 20%;
          }
          &:nth-child(5) {
            flex-basis: 20%;
          }
        }
      }
    }
    .company-data-body {
      position: relative;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            padding: 5px 0.4%;
            line-height: 55px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 20%;
            }
            &:nth-child(2) {
              flex-basis: 20%;
            }
            &:nth-child(3) {
              flex-basis: 20%;
            }
            &:nth-child(4) {
              flex-basis: 20%;
            }
            &:nth-child(5) {
              flex-basis: 20%;
            }
            /deep/ .el-button.is-plain {
              background-color: white;
              color: #be2316;
              border-color: #be2316;
              padding: 7px 4px !important;
              width: 56px;
              span > i {
                transition: 1s all;
                transform: rotateZ(90deg);
                &.expand {
                  transform: rotateZ(-90deg);
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .company-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
</style>

